import * as React from "react";

const fields = (t) => {return {
    config: {columns: 1},
    fields: [

        {
            name: "model",
            label: t ? t("common.model") : "Model",
            readOnly: true,
            column: 1,
        },
        {
            name: "serialNumber",
            label: t ? t("common.serial_number") : "Numer seryjny",
            readOnly: true,

            column: 1,
        },
        {
            name: "productionYear",
            label: t ? t("common.production_year") : "Rok produkcji",
            readOnly: true,

            column: 1,
        },
        {
            name: "files",
            label: t ? t("common.photos") : "Zdjęcia",
            column: 1,
            type: "file"
        },
    ]


}};

export default fields;